import { useTranslation } from 'react-i18next';
import { useAddWhTaskItems } from 'api/warehouse-task/use-add-wh-task-items';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard';
import { FormDrawerWithButton, EFormDrawerSize } from 'components/common/form-drawer-with-button';
import type { IWhTaskItemsAddFormFields } from 'components/wh-tasks/wh-task-items-add/components/wh-task-items-add-form';
import { WhTaskItemsAddForm } from 'components/wh-tasks/wh-task-items-add/components/wh-task-items-add-form';
import type { IWhTaskItemsAddProps } from './types';

export const WhTaskItemsAddComponent = (props: IWhTaskItemsAddProps) => {
  const { whTaskId } = props;
  const { t } = useTranslation();

  const { mutateAsync: addWhTaskItems, isLoading } = useAddWhTaskItems(whTaskId);

  const handleFinish = async (values: IWhTaskItemsAddFormFields) => {
    await addWhTaskItems(values);
  };

  return (
    <FormDrawerWithButton
      formComponent={WhTaskItemsAddForm}
      title={t('wh-task:add_wh_task_items')}
      buttonType='default'
      buttonLabel={t('wh-task:add_wh_task_items')}
      isLoading={isLoading}
      size={EFormDrawerSize.LARGE}
      onFinish={handleFinish}
    />
  );
};

export const WhTaskItemsAdd = withRoleGuard<IWhTaskItemsAddProps>(WhTaskItemsAddComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.customer_manager,
]);
